/* Sticky nav behavior:
   - Adds .is-scrolled when the page is scrolled past the hero
   - Toggles the mobile drawer + scrim + body scroll lock
   - Closes the drawer on link-click / escape / scrim-click */

export function initNav() {
  const nav = document.querySelector('[data-nav]');
  if (!nav) return;

  const scrollThreshold = 40;
  const updateScrollState = () => {
    nav.classList.toggle('is-scrolled', window.scrollY > scrollThreshold);
  };
  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });

  const toggle = nav.querySelector('[data-nav-toggle]');
  const drawer = nav.querySelector('[data-nav-drawer]');
  const scrim  = nav.querySelector('[data-nav-scrim]');
  if (!toggle || !drawer) return;

  const open = () => {
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('nav-locked');
    toggle.setAttribute('aria-expanded', 'true');
  };
  const close = () => {
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('nav-locked');
    toggle.setAttribute('aria-expanded', 'false');
  };

  toggle.addEventListener('click', () =>
    drawer.classList.contains('is-open') ? close() : open()
  );
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('a')) close();
  });
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
